// confirmation-dialog.component.ts
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-confirmation-dialog',
    template: `
    <div class="dialog-container">
      <div class="dialog-icon">
        <mat-icon class="success-icon">check_circle</mat-icon>
      </div>
      <h2 mat-dialog-title class="dialog-title">Registration Successful!</h2>
      <mat-dialog-content class="dialog-content">
        <p class="main-message">
          We have sent a confirmation email to:
        </p>
        <p class="email-address">
          <mat-icon class="email-icon">email</mat-icon>
          {{ data.email }}
        </p>
        <p class="instruction-message">
          Please check your inbox and confirm your registration to complete the process.
        </p>
        <div class="additional-info">
          <mat-icon class="info-icon">info</mat-icon>
          <span>If you don't see the email, please check your spam folder.</span>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions class="dialog-actions">
        <button mat-raised-button color="primary" (click)="close()" class="close-button">
          Got it!
        </button>
      </mat-dialog-actions>
    </div>
  `,
    styles: [`
    .dialog-container {
      padding: 20px;
      text-align: center;
      max-width: 500px;
    }

    .dialog-icon {
      margin-bottom: 20px;
    }

    .success-icon {
      font-size: 64px;
      width: 64px;
      height: 64px;
      color: #4caf50;
      animation: scaleIn 0.3s ease-in-out;
    }

    @keyframes scaleIn {
      0% {
        transform: scale(0);
      }
      50% {
        transform: scale(1.1);
      }
      100% {
        transform: scale(1);
      }
    }

    .dialog-title {
      font-size: 24px;
      font-weight: 600;
      color: #2c3e50;
      margin-bottom: 16px;
    }

    .dialog-content {
      padding: 0 20px 20px;
    }

    .main-message {
      font-size: 16px;
      color: #555;
      margin-bottom: 12px;
    }

    .email-address {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      font-size: 18px;
      font-weight: 600;
      color: #1976d2;
      background-color: #e3f2fd;
      padding: 12px 20px;
      border-radius: 8px;
      margin: 16px 0;
      word-break: break-all;
    }

    .email-icon {
      font-size: 20px;
      width: 20px;
      height: 20px;
    }

    .instruction-message {
      font-size: 15px;
      color: #666;
      margin: 16px 0;
      line-height: 1.5;
    }

    .additional-info {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      background-color: #fff3e0;
      padding: 12px;
      border-radius: 6px;
      margin-top: 16px;
      font-size: 13px;
      color: #e65100;
    }

    .info-icon {
      font-size: 18px;
      width: 18px;
      height: 18px;
      color: #ff9800;
    }

    .dialog-actions {
      justify-content: center;
      padding: 20px 20px 0;
    }

    .close-button {
      padding: 8px 32px !important;
      font-size: 16px !important;
      font-weight: 500 !important;
    }

    @media (max-width: 500px) {
      .dialog-container {
        padding: 15px;
      }

      .dialog-title {
        font-size: 20px;
      }

      .email-address {
        font-size: 14px;
        padding: 10px 15px;
      }

      .main-message,
      .instruction-message {
        font-size: 14px;
      }
    }
  `]
})
export class ConfirmationDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { email: string }
    ) { }

    close(): void {
        this.dialogRef.close();
    }
}